import { ReactNode } from "react";
import { Col, ColProps, Container, Row } from "react-bootstrap";

export function CenteredPage( props: ColProps ) {
    const { children, style = {}, className = "", ...rest } = props;
    return <Container fluid
        className="h-100">
        <Row className="h-100 justify-content-center">
            <Col {...rest}
                className={`${className} h-100 d-flex align-items-center`}
                style={{ ...style, position: "relative", top: "-3%" }}>
                {children}
            </Col>
        </Row>
    </Container>;
}